export const ENTITLEMENT_SERVER_SELECTION_OPTIONS = {
  NOT_SELECTED: 'NOT_SELECTED',
  SPLIT_USE_CASE: 'SPLIT_USE_CASE',
  ENTITLEMENT_SERVER: 'ENTITLEMENT_SERVER',
};

export const ORGANISATION_STATUS = {
  TRIAL: 'Trial',
  PRODUCTION: 'Production',
};

export const IS_PRODUCTION_ENV = 'isLiveViewEnvironment';
